// Thin re-export wrapper — the actual synthesizer + per-key dedup lives in
// /lib/chessSounds.js (single source of truth for every chess sound on the
// platform). This file exists ONLY to keep pre-existing imports of
// `playVictoryOnce` working (LivePuzzle.jsx, CaptureActivityPlayer.jsx)
// without touching each callsite.

import { playChessVictoryOnce, _resetChessSoundsDedupForTests } from './chessSounds';
export const playVictoryOnce = playChessVictoryOnce;
export const _resetVictoryDedupForTests = _resetChessSoundsDedupForTests;
